import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Grid, Input, Dropdown, Button} from 'semantic-ui-react';
import {orderTypes, transportTypes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import ReportGenerator from './reportGenerator';

const {
  loadProviders,
  editInTransitImportsFilter,
  clearInTransitImportsFilters,
} = Actions;

const Header = () => {
  const {loading, updating, downloading, filters} = useSelector((state) => state.providersImportations);
  const loadingProviders = useSelector((state) => state.provider.loading);
  const providers = useSelector((state) => state.provider.list);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadProviders({'withOrigin': true}));
  }, []);

  const clearFilters = () => {
    dispatch(clearInTransitImportsFilters());
  };

  const handleInvoiceChange = (event, data) => {
    dispatch(editInTransitImportsFilter('invoice', data.value.toUpperCase()));
  };

  const handleOptionChange = (event, data) => {
    dispatch(editInTransitImportsFilter(data.name, data.value));
  };

  const parseProviders = (providers = []) => {
    return providers.map((provider) => ({'text': provider.name, 'value': provider.name?.toUpperCase() || ''}));
  };
  
  return (
    <Card raised fluid className='imports-header'>
      <Grid>
        <Grid.Row>
          <Grid.Column width='10' textAlign='left'>
            <h2>Importaciones en tránsito</h2>
          </Grid.Column>
          <Grid.Column width='6' textAlign='right'>
            <Button secondary
              content='LIMPIAR'
              disabled={loading || downloading || updating}
              onClick={clearFilters}
            />
            <ReportGenerator />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row textAlign='left'>
          <Grid.Column width='4'>
            <label><strong>Proveedor</strong></label>
            <Dropdown fluid selection
              name='provider'
              disabled={loadingProviders || loading || downloading || updating}
              options={parseProviders(providers)}
              value={filters.provider}
              onChange={handleOptionChange}
            />
          </Grid.Column>
          <Grid.Column width='2'>
            <label><strong>Tipo</strong></label>
            <Dropdown fluid selection
              name='orderType'
              disabled={loading || downloading || updating}
              options={orderTypes}
              value={filters.orderType}
              onChange={handleOptionChange}
            />
          </Grid.Column>
          <Grid.Column width='2'>
            <label><strong>Vía</strong></label>
            <Dropdown fluid selection
              name='transport'
              disabled={loading || downloading || updating}
              options={transportTypes}
              value={filters.transport}
              onChange={handleOptionChange}
            />
          </Grid.Column>
          <Grid.Column width='4'>
            <label><strong>Factura</strong></label>
            <Input fluid
              name='invoice'
              maxLength='10'
              disabled={loading || downloading || updating}
              value={filters.invoice}
              onChange={handleInvoiceChange}
            />
          </Grid.Column>
          <Grid.Column width='4'>
            <label><strong>Estado</strong></label>
            <Dropdown fluid selection
              name='status'
              disabled={loading || downloading || updating}
              options={[{
                'text': 'Pendientes',
                'value': 'pending',
              }, {
                'text': 'Liquidadas',
                'value': 'liquidated',
              }]}
              value={filters.status}
              onChange={handleOptionChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card>
  );
};

export default Header;
